import { IPersonalInfoCmsMobile, IProduct } from '@vfit/consumer/data-access';

const organizeRetriveFiscalCodeEnergy = (
  nameFiscalCodeCms: IPersonalInfoCmsMobile,
  product?: IProduct | null
) => ({
  title: nameFiscalCodeCms?.personalinfomobile?.firstCard?.title || '',
  description: nameFiscalCodeCms?.personalinfomobile?.firstCard?.description || '',
  firstNameLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.firstName || '',
  lastNameLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.lastName || '',
  fiscalCodeLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.fiscalCode || '',
  buttonLabel: nameFiscalCodeCms?.personalinfomobile?.firstCard?.fcMissingLabel || '',
  legacyPopup: {
    legacyPopupIsOpen: true,
    legacyPopupTitle:
      product?.commonOverride?.legacyCtc?.title ||
      nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.title ||
      '',
    legacyPopupMessage:
      product?.commonOverride?.legacyCtc?.description ||
      nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.description ||
      '',
    legacyPopupActionText:
      product?.commonOverride?.legacyCtc?.buttonLabel ||
      nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.buttonLabel ||
      '',
    legacyPopupUrl: product?.commonOverride?.legacyCtc?.buttonLabel
      ? product?.commonOverride?.legacyCtc?.url || ''
      : product?.commonOverride?.legacyCtc?.url ||
        nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.url ||
        '',
  },
});

export { organizeRetriveFiscalCodeEnergy };
